import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import { GeographyType } from "../../components/GeoSelect/GeoTypes";
import MessagePageHeader from "../../components/MessagePageHeader/MessagePageHeader";
import MessagePageSubHeader from "../../components/MessagePageSubHeader/MessagePageSubHeader";
import SelectTerritory from "../../components/SelectTerritory/SelectTerritory";
import { useGlobalState } from "../../data/global/hooks";
import { useClientRoutesAndLabels } from "../../ui/routes";
import HcpList from "../Messages/HcpList";

const Email: React.FC = () => {
  const { selectedGeoType } = useGlobalState();
  const { client: selectedClient } = useParams() as { client: string };
  const { t, i18n } = useTranslation();
  const routes = useClientRoutesAndLabels(selectedClient);

  if (selectedGeoType !== GeographyType.Territory) {
    return <SelectTerritory client={selectedClient} />;
  }

  return (
    <div>
      <MessagePageHeader client={selectedClient} path={routes.client.print.email} isPrint={false} />
      <BreadCrumbs />
      <div>
        <MessagePageSubHeader client={selectedClient} />
        <HcpList
          client={selectedClient}
          isPrint={false}
          footnote={
            i18n.exists(`email.footnote.${selectedClient}`)
              ? t(`email.footnote.${selectedClient}`)
              : t(`email.footnote.default`)
          }
        />
      </div>
    </div>
  );
};

export default Email;
